export namespace LPCreatePageStates {
    export function lpCreatePageStatesFactory() {
        const lpCreatePage = {
            reload: new Date(),
            onMarketProperty: [],
        };
        return lpCreatePage;
    }

    export function mutations() {
        return {
            lpCreatePageReload(state: any) {
                state.lpCreatePage.reload = new Date();
            },
            setOnMarketProperty(state: any, properties: any) {
                state.lpCreatePage.onMarketProperty = properties;
            },
            clearOnMarketProperty(state: any) {
                state.lpCreatePage.onMarketProperty = [];
            }
        };
    }
}
